module.exports = __webpack_public_path__ + "img/50.c659bfbe.svg";